// extracted by mini-css-extract-plugin
module.exports = {"checkBoxField":"style_checkBoxField__3sOPp","label":"style_label__3tpWk"};